import { PAYWAY_GROUPS_TYPES } from '@/base/const/payway.const'

const formatFee = value => Number(value).toFixed(2).replace('.', ',')

export const isPaywallView = paymentData => paymentData !== null

export const isConfirmationView = confirmationData => confirmationData !== null

export const isPaymentFeeActive = ({ paymentData = null, confirmationData = null } = {}) => {
  const data = isPaywallView(paymentData) ? paymentData : confirmationData
  // sprawdzamy flagę - czy wyświetlać prowizję - bez tego mamy model merchanta a nie płatnika
  // weryfikacja SIDa (PAYMENT_FEE_SID_CONFIG) odbywa się wyłącznie w store payment
  if (!data || !data?.visibilityOptions) return false
  return data.visibilityOptions.showFrontFees
}

export const isPaymentFeeLegacyMode = (paymentData = null) => {
  return paymentData != null && paymentData.customerFee !== undefined
}

export const getPaymentFeeList = (paymentData = null) => {
  return (paymentData?.paywayGroups || [])
    .flatMap(group => group.payways || [])
    .map(payway => Number(payway.customerFee))
}

export const isPaymentFeeDifferent = ({ paymentData = null, confirmationData = null } = {}) => {
  if (isConfirmationView(confirmationData)) {
    return false
  }

  return new Set(getPaymentFeeList(paymentData)).size > 1
}

export const getPaymentFeeAsSingleValue = ({ paymentData = null, confirmationData = null } = {}) => {
  if (isConfirmationView(confirmationData)) {
    return formatFee(confirmationData?.transaction.customerFee)
  }

  if (isPaymentFeeLegacyMode(paymentData)) {
    return formatFee(paymentData.customerFee)
  }

  if (!isPaymentFeeDifferent({ paymentData, confirmationData })) {
    const feeList = getPaymentFeeList(paymentData)
    return Number(feeList[0]) || 0
  }

  return null
}

export const getPaymentFeeForGroup = (group, currency = 'PLN') => {
  const feeList = group.payways.map(payway => Number(payway.customerFee))
  if (feeList.length === 0) return formatFee(0) + ' ' + currency

  const min = Math.min(...feeList)
  const max = Math.max(...feeList)
  return min === max ? formatFee(min) + ' ' + currency : `${formatFee(min)} - ${formatFee(max)} ${currency}`
}

export const getPaymentFeeForPaywayAsNumber = payway => Number(payway.customerFee)

export const getPaymentFeeForActivePaywayAsNumber = ({ paymentData = null, paywayID = null } = {}) => {
  if (!paywayID) return 0

  const payway = (paymentData?.paywayGroups || [])
    .flatMap(group => group.payways || [])
    .find(payway => payway.id === paywayID)

  return payway ? Number(payway.customerFee) : 0
}

export const getPaymentFeeForPayway = (payway, currency = 'PLN') => {
  return formatFee(payway.customerFee) + ' ' + currency
}

export const sortPaymentGroups = (groups = []) => {
  const idx = groups.findIndex(group => group.type === PAYWAY_GROUPS_TYPES.blik)
  if (idx === -1) return [...groups]
  return [...groups.slice(0, idx), ...groups.slice(idx + 1), groups[idx]]
}
